module.exports = __webpack_public_path__ + "static/img/ljhy_yfy_img.daa103a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/ljhy_yfy_img.png
// module id = i8zE
// module chunks = 0